export class UsuarioModel {
    // idUsuario: string;
    // nome: string;
    // sistema: string;
    // dsEntidade: string;
    // nomeGrupo: string;
    token: string;
    // idGrupo: string;
    // idEntidade: string;
    dadosUsuario: any = [];
    permissoes: any = [];

    constructor(UsuariosInfo: any = null) {
        if (UsuariosInfo != null) {

            this.dadosUsuario = UsuariosInfo.dadosUsuarios;
            this.permissoes = UsuariosInfo.permissoes;

            //UsuariosInfo.forEach(item => {

            // this.idUsuario = UsuariosInfo.idUsuario;
            // this.nome = UsuariosInfo.nome;
            // this.idGrupo = UsuariosInfo.idGrupo;
            // this.sistema = UsuariosInfo.sistema;
            // this.dsEntidade = UsuariosInfo.dsEntidade;
            // this.nomeGrupo = UsuariosInfo.nomeGrupo;
            this.token = UsuariosInfo.token;
            // this.permissoes = UsuariosInfo.permissoes;
            // this.idEntidade = UsuariosInfo.idEntidade;

            // });
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/UsuarioModel.ts